import { ModalTransition } from '@atlaskit/modal-dialog';
import moment from 'moment';
import React, {useState,useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';


import { goToRoomWithToken } from '../../../../../utils';
import { Icon, IconAcceptCall, IconRejectCall } from '../../../base/icons';
import { setSchedCallDialog, setSchedCallInfo } from '../../../settings';
import { meetService,callService2 } from '../../../../../service';
import useCountDown from 'react-countdown-hook';
import RingTone from './RingTone';

export interface ScheduleCallPopupProps {
    scheduleCallInfo?: Object,
    onAcceptCall?: Function,
    onRejectCall?: Function
}


const initialTime = 60 * 1000; // initial time in milliseconds, defaults to 60000
const interval = 1000;
const ScheduleCallPopup: FC<ScheduleCallPopupProps> = props => {
    const { scheduleCallInfo, onRejectCall, onAcceptCall } = props;
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();

    //console.log('????????????');
    const dispatch = useDispatch();
    // const startDate = moment(scheduleCallInfo.meetingSchedule.startDate).format('YYYY-MM-DD HH:MM');
    // const endDate = moment(scheduleCallInfo.meetingSchedule.endDate).format('YYYY-MM-DD HH:MM');


    //console.log(scheduleCallInfo, 'scheduleCallInfo');
    const [timeLeft, { start, pause, resume, reset }] = useCountDown(initialTime, interval);
    const [counterstart, setCounterStart] = useState(false);
    const { user } = useSelector(state => state['features/settings']);

    const handleAccept = async () => {
        const id = scheduleCallInfo.meetingSchedule.id;

        dispatch(setSchedCallDialog(false));
        await callService2.joinCall(id);
        const meeting = await meetService.createMeeting(id, `${user.firstName} ${user.lastName}`, user.email,user.id);
        const meetingrest = await meetService.getMeetingData(meeting?.data?.id);

        goToRoomWithToken(meetingrest.authRoom, meetingrest.token);
    };

    const handleReject =  async () => {
        const id = scheduleCallInfo.meetingSchedule.id;

        await callService2.rejectCall(id);
        dispatch(setSchedCallDialog(false));
        dispatch(setSchedCallInfo());
    };

    useEffect(() => {
        start();
        setCounterStart(true);
    }, []);
    useEffect(()=>{
        if (timeLeft == 0 &&counterstart ) {
            dispatch(setSchedCallDialog(false));
            setCounterStart(false);
        }

    },[timeLeft, counterstart]);
    useEffect(()=> {
        const startDate1 = moment(new Date(scheduleCallInfo.meetingSchedule.startDate)).tz(scheduleCallInfo.meetingSchedule.timeZone).locale('en-US').format('YYYY-MM-DD HH:mm');
        const endDate1 = moment(new Date(scheduleCallInfo.meetingSchedule.endDate)).tz(scheduleCallInfo.meetingSchedule.timeZone).locale('en-US').format('YYYY-MM-DD HH:mm');

        setStartDate(startDate1);
        setEndDate(endDate1);
    }, [ scheduleCallInfo ]);

    return (
        <ModalTransition>
            <div className = 'popup dis-flex jus-center ali-center'>
                <div className = 'sched-call-popup dis-flex flex-column jus-evenly'>
                    <h1 className = 'sched-call-popup-title'>{scheduleCallInfo.meetingSchedule.meetingName}</h1>
                    <p className = 'sched-call-popup-time'>Start: {startDate} - End: {endDate}</p>
                    <div className = 'dis-flex jus-evenly'>
                        <button
                            className = 'sched-call-popup-btn-call dis-flex flex-column jus-center ali-center'
                            onClick = { handleReject }>
                            <Icon
                                size = { 150 }
                                src = { IconRejectCall } />
                            <span className = 'sched-call-popup-title-btn'>Decline</span>
                        </button>
                        <button
                            className = 'sched-call-popup-btn-call dis-flex flex-column jus-center ali-center'
                            onClick = { handleAccept }>
                            <Icon
                                size = { 150 }
                                src = { IconAcceptCall } />
                            <span className = 'sched-call-popup-title-btn'>Accept</span>
                        </button>
                    </div>
                </div>
                <RingTone />
            </div>
        </ModalTransition>
    );
};

ScheduleCallPopup.defaultProps = {
    onAcceptCall: () => {},
    onRejectCall: () => {}
};
export default ScheduleCallPopup;
